import { useFetchApps, useGetListAppNames } from "@lhd/hooks";
import { Form, Select, Spin } from "antd";
import { flatMapDeep } from "lodash";
import debounce from "lodash/debounce";
import { useCallback, useMemo, useRef, useState } from "react";
import { CUSTOM_OPTION, CustomAppSelectOption } from "../constants";
import { FormInstance } from "antd/es/form/Form";
import { ERRORS_MESSAGE } from "@lhd/constants";

const AppSelect = ({
  getFieldClassName,
  form,
}: {
  form: FormInstance<any>;
  getFieldClassName?: (name: string) => string;
}) => {
  const name = "referenced_type";
  const fetchRef = useRef(0);
  const [
    page,
    // setPage,
  ] = useState(1);
  const [filterParams, setFilter] = useState({});
  const {
    data: appData,
    isFetching,
    isLoading,
  } = useGetListAppNames(filterParams);
  const [searchKey, setSearchKey] = useState("");

  const debounceFetcher = useMemo(() => {
    const loadOptions = (name_cont: string) => {
      setSearchKey(name_cont);
      fetchRef.current += 1;
      setFilter({ q: { name_cont } });
    };

    return debounce(loadOptions, 500);
  }, [setFilter, setSearchKey]);

  const appDataWithChildren = useMemo(() => {
    return [
      ...(appData?.data || []),
      ...flatMapDeep(appData?.data || [], "children"),
    ];
  }, [appData?.data]);

  const options = useMemo(() => {
    return (appDataWithChildren || []).map((app) => ({
      label: app.name,
      value: app.id,
    }));
  }, [appDataWithChildren]);

  const value = form.getFieldValue(name);

  const isAppValue = useMemo(() => {
    const valueFind = CUSTOM_OPTION.find((op) => op.value === value);
    return !valueFind;
  }, [value]);
  return (
    <Spin spinning={!!value && !!isAppValue && isLoading && isFetching}>
      <Form.Item
        label="Bizシート選択"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        name={name}
        className={`${getFieldClassName?.("referenced_type")}`}
        validateTrigger="onBlur"
      >
        <Select
          style={{ width: 350 }}
          onClear={() => setFilter({})}
          allowClear
          showSearch
          filterOption={false}
          options={[...CUSTOM_OPTION, ...options].filter((org) =>
            org.label.toLowerCase().includes(searchKey.toLowerCase()),
          )}
          loading={isFetching || isLoading}
          onSearch={debounceFetcher}
          notFoundContent={isFetching ? <Spin size="small" /> : null}
          placeholder="Bizシート選択"
        />
      </Form.Item>
    </Spin>
  );
};
export default AppSelect;
